var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkdayLogo2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 452.771,
    height: 512.001,
    viewBox: "0 0 452.771 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15826",
    "data-name": "Path 15826",
    d: "M214.322,6.624a231.261,231.261,0,0,1,220,137.429,14.577,14.577,0,0,1,1.714,9.425,12.979,12.979,0,0,1-24.823,2.385A205.072,205.072,0,0,0,269.456,36.981a222.247,222.247,0,0,0-93.851-.023A199.228,199.228,0,0,0,63.161,107.236,186.956,186.956,0,0,0,33.73,155.909a12.938,12.938,0,1,1-24.152-9.286,231.243,231.243,0,0,1,204.744-140",
    transform: "translate(-8.712 -6.464)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15827",
    "data-name": "Path 15827",
    d: "M434.831,188.521a25.569,25.569,0,0,1-23.8-16.417A192.876,192.876,0,0,0,341.1,88.3a190.149,190.149,0,0,0-62.844-27.232,210.191,210.191,0,0,0-88.524.046A187.658,187.658,0,0,0,84.415,127.25a174.561,174.561,0,0,0-27.393,45.385A25.394,25.394,0,0,1,37.756,188.1a22.834,22.834,0,0,1-4.4.394A25.622,25.622,0,0,1,9.436,153.74C60.275,35.307,194.254-23.4,315.786,19.505A246.253,246.253,0,0,1,426.4,98.86a243.361,243.361,0,0,1,31.145,51.776,27.044,27.044,0,0,1,2.5,17.39,25.5,25.5,0,0,1-22.276,20.307,22.019,22.019,0,0,1-2.94.185M104.907,72.973a219.62,219.62,0,0,0-71.945,90.192l.764-.509A200.562,200.562,0,0,1,65.2,110.74a258.617,258.617,0,0,1,39.712-37.767m262.355,2.94a218.778,218.778,0,0,1,67.268,86.742l.185.324.417-.417c-.116-.232-.3-.695-.6-1.366a217.825,217.825,0,0,0-67.268-85.283M234.093,30.9c-2.547,0-5.117.046-7.688.139a217.9,217.9,0,0,0-34.016,3.821,249.42,249.42,0,0,1,58.1-3.358q-8.128-.591-16.394-.6",
    transform: "translate(-7.752 -5.496)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8830",
    "data-name": "Rectangle 8830",
    width: 438.381,
    height: 294.116,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8829",
    "data-name": "Rectangle 8829",
    width: 463.116,
    height: 324.181,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15828",
    "data-name": "Path 15828",
    d: "M8.3,28.462A13.357,13.357,0,0,1,18.77,22.279c13.315-.116,26.652-.417,39.944.185A13.842,13.842,0,0,1,71.125,34.876C84.185,88.088,97.036,141.369,110.073,194.6c3.821,16.441,8.475,32.719,10.953,49.438,2.57,15.005,3.08,30.265,5.534,45.316a571.676,571.676,0,0,1,12.157-64.1q25.564-95.274,51.1-190.549A15.7,15.7,0,0,1,205.2,22.326c14.82-.37,29.662-.116,44.482-.116a17.678,17.678,0,0,1,18.363,12.412c12.736,46.311,25.286,92.716,37.952,139.051A832.567,832.567,0,0,1,328.108,264c1.227,8.5,2.385,17,4.145,25.425a1266.1,1266.1,0,0,1,27.463-142.871c8.452-37.7,16.718-75.441,25.263-113.139A15.283,15.283,0,0,1,401.3,22.257c11.995-.069,23.989-.417,35.961.185a10.425,10.425,0,0,1,8.683,14.4Q409.859,169.91,373.887,303a15.487,15.487,0,0,1-14.727,12.782c-18.571.6-37.188.139-55.736.255a13.424,13.424,0,0,1-14.866-10.165c-16.626-61.015-32.9-122.1-49.391-183.162a414.849,414.849,0,0,1-10.86-65.068,541.106,541.106,0,0,1-9.772,58.306q-25.251,94.3-50.688,188.6c-1.9,10.188-13.546,12.2-22.206,11.555-17.274-.324-34.525.394-51.776-.324A12.5,12.5,0,0,1,81.869,305.2Q45.5,172.688,9.23,40.132A68,68,0,0,1,8.3,28.461",
    transform: "translate(-8.302 -22.094)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Workday_logo_02",
    "data-name": "Workday logo 02",
    transform: "translate(-7.752 -5.496)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30698",
    "data-name": "Group 30698",
    transform: "translate(20.362 18.212)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8825",
    "data-name": "Rectangle 8825",
    width: 659.086,
    height: 389.162,
    transform: "translate(-115.739 -115.758)",
    fill: "#f69f1a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_30699",
    "data-name": "Group 30699",
    transform: "translate(7.752 5.496)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8826",
    "data-name": "Rectangle 8826",
    width: 684.416,
    height: 414.526,
    transform: "translate(-115.793 -115.723)",
    fill: "#f28a00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_30704",
    "data-name": "Group 30704",
    transform: "translate(14.976 223.38)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30703",
    "data-name": "Group 30703",
    transform: "translate(-7.239 -9.421)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30702",
    "data-name": "Group 30702",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30701",
    "data-name": "Group 30701",
    transform: "translate(7.237 9.422)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30700",
    "data-name": "Group 30700",
    transform: "translate(-7.237 -9.422)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8827",
    "data-name": "Rectangle 8827",
    width: 669.939,
    height: 525.677,
    transform: "translate(-108.54 -106.357)",
    fill: "#0875e1"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkdayLogo2);
export default __webpack_public_path__ + "static/media/workday_logo_2.ef892d57ac0a7cbe6f9ce9ed32e88d53.svg";
export { ForwardRef as ReactComponent };